/*
 * File: base-input-table.ts
 * File Created: 2024-11-11 09:13:23
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-12-02 10:56:25
 * Modified By: Val Liu
 * -----
 */

import { BaseInputComponent } from "./../../core/lib";
import { Component, Emit, MetaParser, ObjectHelper, Prop } from "@root/core";
import { IBaseComponentUITag, IServer } from "@root/components/interfaces";

export interface IBaseInputTableData {
    "enable-text-add"?: string | true | false;
    "enable-text-edit"?: string | true | false;
    "enable-text-delete"?: string | true | false;
}
const defaultData: Partial<IBaseInputTableData> = {
    "enable-text-add": "w_Add",
    "enable-text-edit": "w_Edit",
    "enable-text-delete": "w_Delete",
};

export interface IBaseInputTableInterfaces {
    base?: string | MetaParser;
    C?: string | MetaParser;
    R?: string | MetaParser;
    U?: string | MetaParser;
    D?: string | MetaParser;
}

export interface IBaseInputTableServers {
    C?: IServer;
    R?: IServer;
    U?: IServer;
    D?: IServer;
}

export interface IBaseInputTableUITags {
    base?: IBaseComponentUITag;
    C?: IBaseComponentUITag;
    R?: IBaseComponentUITag;
    U?: IBaseComponentUITag;
    D?: IBaseComponentUITag;
}

@Component
export default class BaseInputTable extends BaseInputComponent {
    @Prop({ type: Array, default: () => [] })
    declare value: Array<any>;

    /// The URI for this request.
    @Prop({ type: Object, required: false, default: () => ({}) })
    servers!: IBaseInputTableServers;

    @Prop({ type: Object, required: true })
    interfaces!: IBaseInputTableInterfaces;

    @Prop({ type: Object, required: false })
    uiTags?: IBaseInputTableUITags;

    @Prop({ type: Object, required: false })
    declare data: IBaseInputTableData;
    get mergedData() {
        let result = {
            ...defaultData,
        };
        if (this.data) {
            if (
                this.data["enable-text-add"] != null &&
                this.data["enable-text-add"] !== true
            )
                result["enable-text-add"] = this.data["enable-text-add"];
            if (
                this.data["enable-text-edit"] != null &&
                this.data["enable-text-edit"] !== true
            )
                result["enable-text-edit"] = this.data["enable-text-edit"];
            if (
                this.data["enable-text-delete"] != null &&
                this.data["enable-text-delete"] !== true
            )
                result["enable-text-delete"] = this.data["enable-text-delete"];
        }
        return result;
    }

    @Emit("on-add")
    onAdd(row) {
        (this.ref("C").ref as any)?.hide?.();
        this.reload();
        return row.data;
    }

    // @Emit("on-edit")
    onEdit(row, old) {
        (this.ref("U").ref as any)?.hide?.();
        this.reload();
        this.$emit("on-edit", row.data, old);
    }

    @Emit("on-delete")
    onDelete(row, old) {
        (this.ref("D").ref as any)?.hide?.();
        this.reload();
        return row ? row.data : old;
    }

    @Emit("on-updated")
    onUpdated(data) {
        return data;
    }

    reload() {
        (this.ref("R").ref as any)?.reload?.();
    }

    /// private helpers
    // interfaces
    get infs() {
        return this.interfaces ?? {};
    }
    get tags() {
        return this.uiTags ?? {};
    }
    calServers(row?: any) {
        const whereId = row
            ? {
                  params: {
                      where: {
                          id: row.id,
                      },
                  },
              }
            : {};
        const rtn = {
            C: this.servers.C,
            R: ObjectHelper.deepMerge(this.servers.R, whereId),
            U: ObjectHelper.deepMerge(this.servers.U, whereId),
            D: ObjectHelper.deepMerge(this.servers.D, whereId),
        };
        return rtn;
    }

    // ref CRUD
    ref(type: string, key?: any) {
        const id = `ref-${type}-${key}`;
        let ref = this.$refs[id];
        if (Array.isArray(ref)) ref = ref[0];
        const result = { id, ref };
        return result;
    }
}
